/**
 * Cliente de la API del Servicio Técnico.
 * Igual que ApiLeiten: lanza ApiError si la request falla.
 */

import { ApiError } from './ApiLeiten';

const BASE_URL = process.env.REACT_APP_TS_URL;
const ACCESS_TOKEN = process.env.REACT_APP_TS_ACCESS;

async function request(path, { method = 'GET', raw = false } = {}) {
    const url = `${BASE_URL}${path}`;

    const response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': ACCESS_TOKEN,
        },
    });

    if (!response.ok) {
        throw new ApiError(`${method} ${path} respondió ${response.status}`, {
            status: response.status,
            url,
        });
    }

    return raw ? response.blob() : response.json();
}

/**
 * Ids de los productos que tienen al menos una reparación cargada.
 * Sirve para no ofrecer en los selects equipos sin soluciones (hoy, ~95% del
 * catálogo). El criterio lo define el backend y espeja el de /solutions.
 */
export function getProductsWithSolutions() {
    return request('/api/products-with-solutions');
}

export async function getSolutionsToPoduct(idProduct, idSolution = '') {
    const data = await request(`/api/product/${idProduct}/solutions/${idSolution}`);
    return data.data ? data.data : data;
}

export function getSolutiontToProductId(idProduct, idSolution) {
    return request(`/api/product/${idProduct}/solutions/${idSolution}`);
}

export function getBudget(idProduct) {
    return request(`/api/get-standard/${idProduct}`);
}

// Trae el PDF como blob mandando el header Authorization.
// Es la forma correcta de mostrar el presupuesto: un <iframe src="..."> NO manda
// ese header, así que la API responde 401. Ver PLAN-REFACTOR.md.
export function getBudgetPdf(pathToFile) {
    return request(`/${pathToFile}`, { raw: true });
}
